module.exports = __webpack_public_path__ + "static/loading-c3625aa96bb6b80cd4833e29748970a0.gif";